var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransporteBusRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "qtly74k1tb",
    d: "M0 0L1.448 0 1.448 5.027 0 5.027z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7iiea71oad",
    d: "M0 0L21.616 0 21.616 10.523 0 10.523z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M.724 9.346c-.4 0-.724-.33-.724-.738V5.056c0-.407.324-.737.724-.737.4 0 .724.33.724.737v3.552c0 .408-.324.738-.724.738",
    transform: "translate(1.000000, 1.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.000000) translate(24.551758, 4.319134)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M.724 5.027c-.4 0-.724-.33-.724-.738V.737C0 .33.324 0 .724 0c.4 0 .724.33.724.737V4.29c0 .407-.324.738-.724.738"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.000000) translate(2.191923, 15.476865)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M18.195 5.115C17.535 5.115 17 4.57 17 3.9c0-.672.535-1.217 1.195-1.217.659 0 1.194.545 1.194 1.217 0 .671-.535 1.216-1.194 1.216zm-14.773 0c-.66 0-1.195-.545-1.195-1.216 0-.672.535-1.217 1.195-1.217s1.194.545 1.194 1.217c0 .671-.535 1.216-1.194 1.216zM21.616.017l-.413.136c-3.257 1.078-6.749 1.625-10.379 1.625-3.643 0-7.146-.55-10.411-1.636L0 0v6.789c0 .483.386.875.86.875h1.837v2.122c0 .407.325.737.725.737.4 0 .724-.33.724-.737V7.664H17.47v2.122c0 .407.325.737.725.737.4 0 .724-.33.724-.737V7.664h1.837c.474 0 .86-.392.86-.875V.017z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M13.016 15.78c3.478 0 6.82-.522 9.93-1.552l.862-.285V5.774H2.192v8.146l.87.3c3.112 1.035 6.464 1.56 9.954 1.56M19.555 0H6.445C4.11 0 2.21 1.926 2.193 4.3h21.614C23.79 1.925 21.889 0 19.555 0",
    transform: "translate(1.000000, 1.000000)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteBusRed);
export default __webpack_public_path__ + "static/media/transporteBusRed.2d3ffc62.svg";
export { ForwardRef as ReactComponent };